var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"down-top-padding",attrs:{"fluid":""}},[_c('base-breadcrumb',{attrs:{"title":_vm.page.title,"icon":_vm.page.icon,"breadcrumbs":_vm.breadcrumbs}}),_c('base-card',{attrs:{"heading":"Adicionar Enunciado"}},[_c('form-wordings',{attrs:{"action":"add"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }